import { ScheduleItem } from './components/scheduleItem/scheduleItem';
import { ScheduleProvider } from './schedule.context';

export const ScheduleView = (): JSX.Element => (
  <ScheduleProvider>
    <ScheduleItem />
  </ScheduleProvider>
);
